import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import PeriodPicker from 'pages/parts/PeriodPicker'
import FilterPagination from 'pages/parts/FilterPagination'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'
import useFileDrop from 'pages/parts/useFileDrop'

import { returnSign, formatMoney, formatDate, notify } from "helpers/helpers";
import { POST, PUT, GET, FILE, httpOk } from 'helpers/api'
import HintIcon from 'pages/parts/HintIcon'
import ErrorsModal from './ErrorsModal'

// Потолок подписи к картинке/видео в Telegram — длиннее сервер рассылку не примет
const CAPTION_LIMIT = 1024

function Index() {
	const { t } = useTranslation()

	const tgTypes = [
		{ 'id': 1, 'name': 'Рисунок' },
		{ 'id': 2, 'name': 'Несколько рисунков' },
		{ 'id': 3, 'name': 'Видео' }
	]

	const [selectedItem, setSelectedItem] = useState({ 'tg_type': 1 })
	const [showModal, setShowModal] = useState(false)
	const [errorsItem, setErrorsItem] = useState(null)
	// Отложенная отправка: пока выключена — рассылка уходит сразу, как раньше
	const [isScheduled, setIsScheduled] = useState(false)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const initialFilterData = { pos_id: null, search: '' }
	const initialPagination = { url: '/telegram-notifications', response: null }
	const {
		filterData,
		appliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
		resetFilters,
	} = useFilterSearchPagination({ initialFilterData, initialPagination })
	const [data, setData] = useState([])

	async function searchWithFilter(customFilterData = filterData) {
		var filterDataCopy = { ...customFilterData }
		var filterUrl = "/telegram-notifications"
		var urlParams = ""
		checkFilter()

		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (`/telegram-notifications${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
			setDropdownIsOpen(false)
		}
	}

	function resetFilter() {
		resetFilters({ ...initialFilterData }, searchWithFilter)
	}

	function checkFilter() {
		if (
			filterData.pos_id === null &&
			filterData.search === ''
		) {
			// managed by hook when filters are reset
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function createUpdate(e) {
		e.preventDefault();

		if (isScheduled && !selectedItem.scheduled_at) {
			notify(t('choose_sending_time'))
			return
		}

		// Выключили галочку после выбора даты — отправляем сейчас, время не тащим.
		var selectedItemCopy = { ...selectedItem }
		if (!isScheduled) selectedItemCopy.scheduled_at = null

		var response
		if (selectedItemCopy.id) {
			response = await PUT(`/telegram-notifications/${selectedItemCopy.id}`, selectedItemCopy, { loader: true })
		} else {
			response = await POST('/notifications-telegram-send', selectedItemCopy, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModal(false)
		}
	}

	// Загрузка и с инпута, и с перетаскивания — тип файла зависит от выбранного tg_type
	async function uploadFiles(files) {
		if (!files || !files.length) return

		if (selectedItem.tg_type === 1 || selectedItem.tg_type === 2) {
			const images = Array.from(files).filter(file => file.type?.startsWith('image/'))
			if (!images.length) {
				notify(t('image2'))
				return
			}

			if (selectedItem.tg_type === 1) {
				let formData = new FormData();
				formData.append("image", images[0]);
				formData.append("path", 'notifications');

				const response = await FILE('/upload-image', formData, {}, { loader: true });
				if (httpOk(response)) setSelectedItem({ ...selectedItem, 'image': response.data.url })
			}

			if (selectedItem.tg_type === 2) {
				let formData = new FormData();
				for (let i = 0; i < images.length; i++) {
					formData.append("images[]", images[i]);
				}
				formData.append("path", 'notifications');

				const response = await FILE('/upload-images', formData, {}, { loader: true });
				if (httpOk(response)) setSelectedItem({ ...selectedItem, 'images': response.data.urls })
			}
		}

		if (selectedItem.tg_type === 3) {
			const video = Array.from(files).find(file => file.type?.startsWith('video/'))
			if (!video) {
				notify(t('video'))
				return
			}

			let formData = new FormData();
			formData.append("video", video);
			formData.append("path", 'notifications');

			const response = await FILE('/upload-video', formData, {}, { loader: true });
			if (httpOk(response)) setSelectedItem({ ...selectedItem, 'video': response.data.url })
		}
	}

	async function fileUpload(e) {
		await uploadFiles(e.target.files)
	}

	const { dropProps, dropStyle } = useFileDrop(uploadFiles, { multiple: true })

	// Не ушла вовсе: отложенную сняли или она не стартовала, либо сервер остановил её
	// на первом получателе, потому что ошибка в самом сообщении (тогда started_at уже стоит).
	function isNotSent(item) {
		return item.canceled_at && (!item.started_at || item.fail_reason)
	}

	// Статус заливает ячейку целиком, как в остальных таблицах кабинета
	function returnClassStatus(item) {
		if (item.is_scheduled) {
			return "bg-primary text-white"
		}
		if (isNotSent(item)) {
			return `bg-danger text-white ${item.fail_reason ? 'cursor' : ''}`
		}

	}

	// files в базе лежит строкой: у старых рассылок она могла быть и не json'ом
	function parseImages(files) {
		try {
			return files ? JSON.parse(files) : null
		} catch (e) {
			return null
		}
	}

	function toggleModal(bool, item = {}) {
		setShowModal(bool)

		// Правим только отложенную рассылку, а у неё время есть всегда — галочку с неё снять нельзя.
		if (item.id) {
			setSelectedItem({
				'id': item.id,
				'tg_type': item.tg_type ?? 1,
				'message': item.message ?? '',
				'image': item.image ?? '',
				'images': parseImages(item.files),
				'video': item.video ?? '',
				'scheduled_at': item.scheduled_at,
			})
			setIsScheduled(true)
			return
		}

		setSelectedItem({ 'tg_type': 1 })
		setIsScheduled(false)
	}

	function handlePaginate(page) {
		const nextFilterData = { ...filterData, page }
		paginate(page)
		searchWithFilter(nextFilterData)
	}

	async function cancelSending(item) {
		const response = await POST(`/telegram-notifications/${item.id}/cancel`, {}, { loader: true, notification: true })

		if (httpOk(response)) searchWithFilter()
	}

	// Пока batch не закрыт, счётчики в базе растут — подтягиваем их без глобального лоадера.
	// Иначе на 20 000 подписчиков страница минут десять показывает нули, и непонятно,
	// идёт рассылка или всё зависло.
	const runningIds = (data?.data ?? []).filter(item => item.is_running).map(item => item.id).join(',')

	useEffect(() => {
		if (!runningIds) return

		const ids = runningIds.split(',')
		const timer = setInterval(async () => {
			const responses = await Promise.all(
				ids.map(id => GET(`/telegram-notifications/${id}/progress`))
			)

			setData(prev => ({
				...prev,
				'data': prev.data.map(row => {
					const fresh = responses.find(response => httpOk(response) && response.data.id === row.id)
					return fresh ? { ...row, ...fresh.data } : row
				})
			}))
		}, 5000)

		return () => clearInterval(timer)
	}, [runningIds]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('telegram_notifications')} [{data.total}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, searchWithFilter)}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('period')}</label>
												<PeriodPicker
													withTime={false}
													startDate={filterData.start_date}
													endDate={filterData.end_date}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
													onChange={(period) => patchFilterData(period)}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => applyFilters(searchWithFilter)}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(appliedFilterData.start_date || appliedFilterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{appliedFilterData.start_date &&
											<span>{formatDate(appliedFilterData.start_date)}</span>
										}
										{(appliedFilterData.start_date && appliedFilterData.end_date) &&
											<span>|</span>
										}
										{appliedFilterData.end_date &&
											<span>{formatDate(appliedFilterData.end_date)}</span>
										}
									</span>
								}
								{appliedFilterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{appliedFilterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '42%' }}>{t('description')}</th>
									<th style={{ 'width': '8%' }} className="text-center">{t('image')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('date')}</th>
									<th style={{ 'width': '18%' }} className="text-center">{t('sent_progress')}</th>
									<th style={{ 'width': '8%' }} className="text-end">{t('success')}</th>
									<th style={{ 'width': '8%' }} className="text-end">{t('errors')}</th>
									<th style={{ 'width': '6%' }} className="text-center"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.message}</td>
										<td className="text-center">
											{item.image &&
												<img src={`https://backend.mison.uz/uploads/notifications/${item.image}`}
													width={50} height={50} alt="img" />
											}
										</td>
										{/* У отложенной рассылки важно время запуска, а не создания — оно уходит в подсказку */}
										<td className="text-center text-nowrap"
											title={item.scheduled_at ? `${t('created_at')}: ${formatDate(item.created_at, 'dd.MM.yy HH:mm')}` : ''}>
											{item.scheduled_at ?
												<span className="text-primary">
													<i className="uil uil-clock"></i> {formatDate(item.scheduled_at, 'dd.MM.yy HH:mm')}
												</span>
												:
												<span>{formatDate(item.created_at, 'dd.MM.yy HH:mm')}</span>
											}
										</td>
										<td className={`text-center ${returnClassStatus(item)}`}
											title={item.fail_reason ?? ''}
											onClick={() => isNotSent(item) && item.fail_reason && setErrorsItem(item)}>
											{item.is_scheduled ?
												<span>{t('scheduled')}</span>
												:
												isNotSent(item) ?
													<span>
														{item.fail_reason ? t('not_sent') : t('canceled')}
														{item.fail_reason && <> <i className="uil uil-info-circle"></i></>}
													</span>
													:
													item.total_count > 0 ?
														<>
															<div className="d-flex justify-content-between" style={{ 'fontSize': '12px' }}>
																<span>{formatMoney(item.success_count + item.errors_count)}</span>
																<span>{formatMoney(item.total_count)}</span>
															</div>
															<div className="progress" style={{ 'height': '6px' }}>
																<div className={`progress-bar ${item.is_running ? 'progress-bar-striped progress-bar-animated' : 'bg-success'}`}
																	style={{ 'width': `${Math.min(100, Math.round(((item.success_count + item.errors_count) / item.total_count) * 100))}%` }}>
																</div>
															</div>
														</>
														:
														<span>-</span>
											}
										</td>
										<td className="text-end text-success">
											<b>{formatMoney(item.success_count)}</b>
										</td>
										<td className="text-end text-danger">
											{item.errors_count > 0 ?
												<b className="cursor text-decoration-underline"
													onClick={() => setErrorsItem(item)}>
													{formatMoney(item.errors_count)}
												</b>
												:
												<b>{formatMoney(item.errors_count)}</b>
											}
										</td>
										<td className="text-center">
											<div className="d-flex justify-content-center gap-2">
												{item.is_scheduled &&
													<div className="table-action-button table-action-primary-button"
														title={t('edit')}
														onClick={() => toggleModal(true, item)}>
														<i className="uil-edit-alt"></i>
													</div>
												}
												{(item.is_running || item.is_scheduled) &&
													<div className="table-action-button table-action-danger-button"
														title={item.is_scheduled ? t('cancel_sending') : t('stop_sending')}
														onClick={() => cancelSending(item)}>
														<i className="uil-times"></i>
													</div>
												}
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem.id ? t('edit') : t('create')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<Select
								options={tgTypes}
								value={tgTypes.find(option => option.id === selectedItem.tg_type) || ''}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'tg_type': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						{selectedItem.tg_type === 1 &&
							<div className="form-group p-2 rounded"
								style={dropStyle ?? { border: '1px dashed var(--dark-border-strong, #ced4da)' }}
								{...dropProps}>
								<input type="file" className="form-control" accept="image/jpg,image/jpeg,image/png"
									onChange={(e) => fileUpload(e)} />
								<div className="text-muted fz-14 mt-1">{t('drag_file_here')}</div>
							</div>
						}
						{selectedItem.tg_type === 2 &&
							<div className="form-group p-2 rounded"
								style={dropStyle ?? { border: '1px dashed var(--dark-border-strong, #ced4da)' }}
								{...dropProps}>
								<input type="file" className="form-control" accept="image/jpg,image/jpeg,image/png" multiple
									onChange={(e) => fileUpload(e)} />
								<div className="text-muted fz-14 mt-1">{t('drag_file_here')}</div>
							</div>
						}
						{selectedItem.tg_type === 3 &&
							<div className="form-group p-2 rounded"
								style={dropStyle ?? { border: '1px dashed var(--dark-border-strong, #ced4da)' }}
								{...dropProps}>
								<input type="file" className="form-control" accept="video/mp4"
									onChange={(e) => fileUpload(e)} />
								<div className="text-muted fz-14 mt-1">{t('drag_file_here')}</div>
							</div>
						}

						{selectedItem.tg_type === 2 &&
							<div className="mb-2"><b className="text-success">Зажмите ctrl для выбора несколько файлов</b></div>
						}
						{(selectedItem.tg_type === 1 && selectedItem.image) &&
							<div className="d-flex gap-3">
								<div style={{ 'width': '188px', 'height': '140px' }}>
									<img alt={selectedItem.image}
										src={`https://backend.mison.uz/uploads/notifications/${selectedItem.image}`}
										style={{ 'maxWidth': '100%', 'maxHeight': '100%' }} />
								</div>
							</div>
						}
						{(selectedItem.tg_type === 2 && selectedItem.images) &&
							<div className="d-flex gap-3">
								{selectedItem?.images?.map((item, index) => (
									<div style={{ 'width': '188px', 'height': '140px' }} key={index}>
										<img alt={item}
											src={`https://backend.mison.uz/uploads/notifications/${item}`}
											style={{ 'maxWidth': '100%', 'maxHeight': '100%' }} />
									</div>
								))}
							</div>
						}

						<div className="form-group">
							<label>{t("text")}</label>
							<textarea className="form-control" rows="5"
								value={selectedItem.message ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'message': e.target.value })}>
							</textarea>
							<div className={`text-end fz-14 ${(selectedItem.message ?? '').length > CAPTION_LIMIT ? 'text-danger' : 'text-muted'}`}>
								{(selectedItem.message ?? '').length} / {CAPTION_LIMIT}
							</div>
						</div>

						<div className="form-group">
							<div className="form-check">
								<input type="checkbox" className="form-check-input" id="scheduled-sending"
									checked={isScheduled}
									disabled={!!selectedItem.id} // правим уже запланированную: время у неё есть всегда
									onChange={(e) => setIsScheduled(e.target.checked)} />
								<label className="form-check-label" htmlFor="scheduled-sending">
									{t('schedule_sending')}
								</label>
							</div>
						</div>

						{isScheduled &&
							<div className="form-group">
								<label>{t('sending_time')}<HintIcon text={t('sending_time_hint')} /></label>
								<div className="calendar-input">
									<DatePicker
										showMonthDropdown
										showYearDropdown
										dropdownMode="select"
										yearDropdownItemNumber={2}
										minDate={new Date()}
										maxDate={new Date(new Date().getFullYear() + 1, 11, 31)}
										className="form-control"
										showTimeSelect
										timeFormat="HH:mm"
										timeIntervals={60} // шаг времени в минутах: рассылку запускает часовой крон
										timeCaption={t('time')}
										dateFormat="dd.MM.yyyy HH:mm"
										selected={selectedItem.scheduled_at ? new Date(selectedItem.scheduled_at) : ''}
										onChange={(date) => setSelectedItem({
											...selectedItem,
											'scheduled_at': formatDate(date, 'yyyy-MM-dd HH:mm:ss')
										})} />
									<i className="uil uil-calendar-alt"></i>
								</div>
							</div>
						}

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal >
			{/* MODAL */}

			<ErrorsModal notification={errorsItem} onHide={() => setErrorsItem(null)} />
		</>
	)
}

export default Index